import { EventShowcase } from "../events/EventShowcase";
import { PageIntro } from "./PageIntro";

export function EventsPage() {
  return (
    <div className="standard-page events-page">
      <PageIntro eyebrow="YEAR-ROUND HIGHLIGHTS" title="台東活動" en="EVENTS">
        <p>
          從月光海、藝術節到衝浪與部落音樂，沿著季節安排一趟屬於你的台東旅程。
          活動日期僅供參考，每年日期依主辦單位公告為主。
        </p>
      </PageIntro>
      <EventShowcase />
    </div>
  );
}
